import React from "react";

import { formatCurrency } from "../utils/constants"

function EventSelection(props) {
  const { events, language } = props;
  if (events.length === 0) {
    return (
      <div className="bg-white text-center py-4 lg:px-4 h-64">
        <p className="font-bold">Events coming soon! Please check back later.</p>
      </div>
    )
  }
  return (
    <div>
      <p className="text-center font-bold my-4">Please select an event below to purchase your tickets.  </p>
      {events.map((v, k) => (
        <div key={`eventSelection${k}`}>
          <a href={`/?eventId=${v.id}`} className="block max-w-sm mx-auto my-4 overflow-hidden rounded-lg no-underline bg-primary-darkest hover:bg-primary-darker">
            <div className="flex items-start px-6 py-4">
              <div className="flex-grow font-bold text-white text-xl">{v.title}</div>
              <div className="bg-grey-lighter rounded-full px-3 py-1 text-xs font-semibold text-grey-darker">{v.game_title}</div>
            </div>
            {v.game_id === 1 && (
              <div className="flex justify-around px-6 py-4">
                <div>
                  <p className="text-white text-center font-light text-base">
                    CURRENT JACKPOT
                    </p>
                  <p className="text-accent text-center font-bold text-4xl">
                    {formatCurrency(v.jackpot)}
                  </p>
                </div>
                <div>
                  <p className="text-white text-center font-light text-base">
                    CURRENT PRIZE
                    </p>
                  <p className="text-accent text-center font-bold text-4xl">
                    {formatCurrency(v.prize)}
                  </p>
                </div>
              </div>
            )}
            
            {v.game_id === 2 && (
              <div className="flex justify-around px-6 py-4">
              <div>
                <p className="text-white text-center font-light text-base">
                  PRIZE
                  </p>
                <p className="text-accent text-center font-bold text-4xl">
                  {v.draws && v.draws[0] && v.draws[0]['title']}
                </p>
              </div>
            </div>
            )}
            
            {v.game_id === 3 && (
              <div className="flex justify-around px-6 py-4">
                <div>
                  <p className="text-white text-center font-light text-base">
                    {language.en.game_3_jackpot_title.toUpperCase()}
                    </p>
                  <p className="text-accent text-center font-bold text-4xl">
                    {formatCurrency(v.jackpot)}
                  </p>
                </div>
                <div>
                  <p className="text-white text-center font-light text-base">
                    {language.en.game_3_prize_title.toUpperCase()}
                    </p>
                  <p className="text-accent text-center font-bold text-4xl">
                    {formatCurrency(v.prize)}
                  </p>
                </div>
              </div>
            )}

          </a>
        </div>
      ))}
    </div>
  );
}

export default EventSelection;
